import { FeatureName } from '@treams/treams-network';

export enum DismissFeatureType {
	FEATURE_ANNOUNCEMENT = 'FEATURE_ANNOUNCEMENT',
	FEATURE_APPROVAL_MODAL = 'FEATURE_APPROVAL_MODAL',
}

export const useDismissFeatures = () => {
	const getSessionStorageKey = (
		dismissFeatureType: DismissFeatureType,
		featureName: FeatureName,
	) => {
		return `DISMISSED_${dismissFeatureType}_${featureName}`;
	};

	const dismissFeature = (dismissFeatureType: DismissFeatureType, featureName: FeatureName) => {
		sessionStorage.setItem(
			getSessionStorageKey(dismissFeatureType, featureName),
			Date.now().toString(),
		);

		return;
	};

	const isFeatureDismissed = (dismissFeatureType: DismissFeatureType, featureName: FeatureName) => {
		return sessionStorage.getItem(getSessionStorageKey(dismissFeatureType, featureName)) !== null;
	};

	const removeFeatureDismissed = (
		dismissFeatureType: DismissFeatureType,
		featureName: FeatureName,
	) => {
		sessionStorage.removeItem(getSessionStorageKey(dismissFeatureType, featureName));
	};

	return { dismissFeature, isFeatureDismissed, removeFeatureDismissed };
};
